import { memo } from "react";
import { LAST_SEEN_POPUP_KEY } from "../configs/constants";
import { useLatestPopup } from "../hooks/useLatestPopupQuery";

const ChangelogCounter = memo(() => {
  const { changelog } = useLatestPopup();

  if (!changelog) return null;

  const lastSeenId = localStorage.getItem(LAST_SEEN_POPUP_KEY);
  if (lastSeenId === changelog.id) return null;

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  if (new Date(changelog.created_at) < oneMonthAgo) return null;

  return (
    <span className="relative z-10 flex shrink-0 size-2.5 rounded-full bg-orange-400" />
  );
});

export default ChangelogCounter;
